import { useState } from "react";
import AdminLayout from "../../../components/AdminLayout";
import { Cabecalho, Pagina } from "../../../components/AdminLayout/Pagina";
import ListaUsuariosModal from "../../Gerenciamento/ListaUsuariosModal";
import UsuariosModal from "../../Gerenciamento/UsuariosModal";
import { tiposGerenciamentoModal } from "../../../../utils/data";

// Gestão de usuários como PÁGINA: busca, filtros por tipo e status e as ações
// (promover/rebaixar, ativar/desativar). A edição de dados continua num modal,
// aberto sobre a página.
export default function Usuarios() {
  const [usuario, setUsuario] = useState({});
  const [edicao, setEdicao] = useState(tiposGerenciamentoModal.NONE);
  // Sobe quando a edição fecha, para a lista buscar de novo e mostrar o que mudou.
  const [versao, setVersao] = useState(0);

  return (
    <AdminLayout>
      <Pagina>
        <Cabecalho titulo="Usuários" descricao="Busque pessoas, mude o perfil (Comum ou Profissional) e ative ou desative contas." />
        <div style={{ width: "100%" }}>
          <ListaUsuariosModal pagina versao={versao} setUsuario={setUsuario}
            openEditModal={() => setEdicao(tiposGerenciamentoModal.INFORMACOES)} />
        </div>
        <UsuariosModal usuario={usuario} setUsuario={setUsuario} tipo={edicao}
          onClose={() => { setEdicao(tiposGerenciamentoModal.NONE); setVersao((v) => v + 1); }} />
      </Pagina>
    </AdminLayout>
  );
}
